export const AUTH_MODAL_TITLE = 'How can we help you?';
export const PERSONAL_DETAILS = 'Personal Details';
export const DETAILED_MSG = 'Please start filling out your application by filling in your personal information below.';
export const ALREADY_HAVE_ACCOUNT = 'Already have an account?';
export const LOGIN = 'Log in';
export const DESCRIPTION_TITLE = `We're here to help! Please provide details about your needs.`;
export const MESSAGE_PLACEHOLDER = 'Enter your message...';
export const CONFIRM_BTN = 'Confirm';